import { render, staticRenderFns } from "./BundleSelection.vue?vue&type=template&id=01ce5715&scoped=true&"
import script from "./BundleSelection.vue?vue&type=script&lang=ts&"
export * from "./BundleSelection.vue?vue&type=script&lang=ts&"
import style0 from "./BundleSelection.vue?vue&type=style&index=0&id=01ce5715&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ce5715",
  null
  
)

export default component.exports